export const VIDEO_DOWNLOADER_KEYWORD_DEFAULT = 'YouTube'
